module.exports = __webpack_public_path__ + "img/image-placeholder.eac14cdb.jpg";